import React, { CSSProperties, useEffect, useState } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import { useAppSelector } from 'redux/hooks';
import WithPermission from 'hooks/WithPermission';
import { selectUserData } from 'redux/editProfile/userProfile.slices';
import downArrow from 'assets/icons/down-arrow.svg';
import './NavigationDrawer.scoped.scss';

interface SubMenus {
  name: string;
  path: string;
  code: string;
}

interface Props {
  icon?: string;
  path?: string;
  name?: string;
  isOpen: boolean;
  style?: CSSProperties;
  hasAccess: boolean;
  permission: string;
  subMenus?: SubMenus[];
  onLayoutChange?: (val: boolean) => void;
  selectedSubMenu?: string;
  setSelectedSubMenu?: React.Dispatch<React.SetStateAction<string>>;
}

const NavigationItem: React.FC<Props> = ({
  style,
  icon,
  path,
  name,
  isOpen,
  permission,
  hasAccess,
  subMenus,
  onLayoutChange,
  selectedSubMenu,
  setSelectedSubMenu,
}) => {
  const [active, setActive] = useState<boolean>(false);
  const [image, setImage] = useState();
  const history = useHistory();
  const location = useLocation();
  const user = useAppSelector(selectUserData);

  function clearPathName(url: string) {
    const deepRoute = url.split('/').length > 2 && url.split('/')[1];
    return deepRoute ? `/${deepRoute}` : url;
  }

  useEffect(() => {
    if (path && clearPathName(location.pathname) === path) {
      setActive(true);
    } else {
      setActive(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const handleActiveSubmenu = (path: string) => {
    if (path && clearPathName(location.pathname) === path) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    (async () => {
      const img = active
        ? await import(`assets/icons/${icon}-active.svg`)
        : await import(`assets/icons/${icon}.svg`);
      setImage(img.default);
    })();
  }, [active]);

  function handleSubMenu(openDrawer: boolean) {
    openDrawer && onLayoutChange(false);
    if (name === selectedSubMenu) {
      setSelectedSubMenu('');
    } else {
      setSelectedSubMenu(name);
    }
  }

  function handleClick(path) {
    if (history.location.pathname.includes(path) && path !== '/') return;
    history.push(`${path}`);
  }

  useEffect(() => {
    if (isOpen) {
      setSelectedSubMenu('');
    }
  }, [isOpen]);

  function renderNav() {
    // eslint-disable-next-line no-empty
    if (subMenus) {
      return (
        <div className={selectedSubMenu === name ? 'sidebar-item openSubMenu' : 'sidebar-item'}>
          <div
            className={`${isOpen && 'closed'} ${active && 'active'}
            navigation-drawer-item pointer contains-arrow`}
            style={style}
            onClick={() => handleSubMenu(true)}
          >
            <div className="title-container-flex">
              <img src={image} alt={icon} style={{ color: 'black' }} />
              <h2 className={`${!isOpen ? 'open' : 'close'}  name`}>{name}</h2>
            </div>
            {!isOpen && (
              <div>
                <img
                  src={downArrow}
                  alt="down-icon"
                  className="toggle-btn"
                  style={{ color: 'black' }}
                />
              </div>
            )}
          </div>
          <div className="submenu-content">
            {subMenus.map(el => (
              <div
                key={el.name}
                className={'submenu navigation-drawer-item pointer'}
                style={style}
                onClick={() => handleClick(el.path)}
              >
                <h2
                  // eslint-disable-next-line prettier/prettier
                  className={`${!isOpen ? 'open' : 'close'} ${
                    handleActiveSubmenu(el.path) ? 'activeSubName' : 'passiveSubName'
                  } subname`}
                >
                  {el.name}
                </h2>
              </div>
            ))}
          </div>
        </div>
      );
    }
    return (
      <div
        className={`${isOpen && 'closed'} ${active && 'active'} navigation-drawer-item pointer`}
        style={style}
        onClick={() => {
          handleSubMenu(false);
          handleClick(path);
        }}
      >
        <img src={image} alt={icon} style={{ color: 'black' }} />
        <h2 className={`${!isOpen ? 'open' : 'close'}  name`}>{name}</h2>
      </div>
    );
  }

  return user !== null && hasAccess ? (
    <WithPermission permissionRequired={permission}>{renderNav()}</WithPermission>
  ) : (
    renderNav()
  );
};

export default NavigationItem;
